import { useShouldShowOnboarding } from 'pages/onboarding/useShouldShowOnboarding';
import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AppSkeleton } from 'ui/wrappers/AppSkeleton';

export const onboardingPath = '/onboarding';

/**
 * Sends a user whose tenant has not been onboarded to the onboarding flow.
 *
 * Wraps the app rather than a single route so that a deep link cannot be used to arrive past it.
 * Shows the app-shell skeleton while the tenant is loading.
 */
export const RequireOnboarding: React.FC<PropsWithChildren<object>> = ({ children }) => {
    const { isLoading, shouldShowOnboarding } = useShouldShowOnboarding();
    const location = useLocation();

    if (isLoading) {
        return <AppSkeleton />;
    }

    if (shouldShowOnboarding && location.pathname !== onboardingPath) {
        return <Navigate to={onboardingPath} replace />;
    }

    return <>{children}</>;
};
